// Shared sensitivity detection. Labels come from three sources on each post:
//   - post.labels (AppView aggregate)
//   - post.record.labels.values (self-applied)
//   - post.author.labels (account-level)
// All flattened into a string[] before being persisted on MediaItemRow.

export const SENSITIVE_LABELS = new Set([
  // sexual / nudity
  'porn',
  'sexual',
  'sexual-content',
  'sexual-figurative',
  'nudity',
  'nude',
  'suggestive',
  'underwear',
  // graphic / violence
  'graphic-media',
  'gore',
  'violence',
  'violent',
  'corpse',
  'self-harm',
  'selfharm',
  // hateful
  'hate',
  'intolerant',
  'hate-speech',
])

export function isSensitive(labels: string[] | undefined): boolean {
  if (!labels || labels.length === 0) return false
  for (const raw of labels) {
    const l = String(raw ?? '').toLowerCase()
    if (SENSITIVE_LABELS.has(l)) return true
    if (l.startsWith('!') && l.includes('hide')) return true
    if (l.includes('porn') || l.includes('sexual') || l.includes('nud')) return true
  }
  return false
}
